exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".carEditor-mainfield {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  overflow-x: auto;\n  overflow-y: auto;\n  margin: 0px;\n  padding: 0px;\n  z-index: 1; }\n\n.carEditor-mainfieldBody {\n  display: block;\n  position: relative;\n  top: 0px;\n  left: 0px;\n  width: 1440px;\n  height: 100%;\n  background-color: white;\n  margin-right: auto;\n  margin-left: auto; }\n\n.carEditor-menu {\n  display: block;\n  position: fixed;\n  top: 0px;\n  background-color: white;\n  width: 1440px;\n  z-index: 200; }\n\n.carEditor-body {\n  display: block;\n  position: relative;\n  left: 0px;\n  padding: 0 !important;\n  background-color: white;\n  width: 1440px;\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/CarEditorPage/styles.scss
// module id = 1743
// module chunks = 0